import { useEffect, useState } from "react";
import type { ReactElement } from "react";

/**
 * Band am oberen Rand, solange das Gerät keine Verbindung hat. Es ersetzt keine
 * Fehlerseite — die Anwendung bleibt mit ihrem letzten Stand sichtbar (Liste, Akte, …
 * kommen ohnehin nie aus einem lokalen Datenbestand, siehe sw.ts), es kommt nur ein
 * Hinweis obendrauf. role="status" statt role="alert": Screenreader melden die Änderung,
 * ohne den Fokus zu stehlen — es ist kein Fehler, der eine Handlung verlangt.
 */
export function OfflineHinweis(): ReactElement | null {
  const [offline, setOffline] = useState(
    () => typeof navigator !== "undefined" && navigator.onLine === false,
  );

  useEffect(() => {
    const aufOffline = (): void => setOffline(true);
    const aufOnline = (): void => setOffline(false);
    window.addEventListener("offline", aufOffline);
    window.addEventListener("online", aufOnline);
    return () => {
      window.removeEventListener("offline", aufOffline);
      window.removeEventListener("online", aufOnline);
    };
  }, []);

  if (!offline) return null;

  return (
    <div className="offline-hinweis" role="status">
      Keine Verbindung. Die angezeigten Daten stammen vom letzten Aufruf und lassen sich
      derzeit nicht ändern.
    </div>
  );
}
